import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientIPAddressService {
  private readonly fallbackResponse = {
    response: {
      query: '',
      country: '',
      state: '',
      city: '',
    },
  };

  constructor(private http: HttpClient) {}

  getClientIp() {
    return this.http.get('https://ipapi.co/json/').pipe(
      map((response: any) => ({
        response: {
          query: response?.ip ?? '',
          country: response?.country_name ?? '',
          state: response?.region ?? '',
          city: response?.city ?? '',
        },
      })),
      catchError(() => of(this.fallbackResponse))
    );
  }

}
